var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDocumento(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 70,
    viewBox: "0 0 54 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0564 36.1978H40.9436V32.3089H13.0564V36.1978ZM13.0564 46.9661H40.9436V43.0772H13.0564V46.9661ZM13.0564 57.7383H29.3721V53.8494H13.0564V57.7383ZM6.22929 70C4.455 70 2.97386 69.4011 1.78586 68.2033C0.597856 67.0055 0.00257143 65.5109 0 63.7194V6.28055C0 4.49166 0.595285 2.99833 1.78586 1.80056C2.97643 0.602778 4.45886 0.00259259 6.23314 0H36.6429L54 17.5V63.7194C54 65.5083 53.406 67.003 52.218 68.2033C51.03 69.4037 49.5463 70.0026 47.7669 70H6.22929ZM34.7143 19.4444H50.1429L34.7143 3.88889V19.4444Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumento);
export default __webpack_public_path__ + "static/media/ic_documento.653a05406a32cca54c3c12bf225e45c2.svg";
export { ForwardRef as ReactComponent };